import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { api } from '../../api/mockData';
import './index.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [siteConfig, setSiteConfig] = useState(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const navigate = useNavigate();

  // 监听滚动
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 获取用户和网站配置
  useEffect(() => {
    // 模拟获取当前用户
    const mockUser = {
      id: 1,
      name: '猫奴小橘',
      avatar: 'https://images.unsplash.com/photo-1561948955-570b270e7c36?w=40&h=40&fit=crop&crop=face',
      bio: '爱猫人士 · 家有两只猫咪',
      email: 'catlover@example.com'
    };
    
    setCurrentUser(mockUser);
    
    // 模拟网站配置
    const mockSiteConfig = {
      title: '喵星人日记',
      subtitle: '记录与猫咪共度的美好时光'
    };
    
    setSiteConfig(mockSiteConfig);
  }, []);

  // 处理登录/登出
  const handleAuth = () => {
    if (currentUser) {
      // 模拟登出
      setCurrentUser(null);
      setUserMenuOpen(false);
      navigate('/');
    } else {
      setUserMenuOpen(false);
      navigate('/auth');
    }
  };

  // 点击个人中心
  const handleUserCenter = () => {
    if (currentUser) {
      navigate('/user');
      setUserMenuOpen(false);
      setIsMenuOpen(false);
    } else {
      navigate('/auth');
    }
  };

  // 点击用户头像
  const toggleUserMenu = () => {
    setUserMenuOpen(!userMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      {/* 顶部装饰条 */}
      <div className="header-top-decoration">
        <div className="cat-paw-line">
          {[...Array(10)].map((_, i) => (
            <span key={i} className="paw-icon">🐾</span>
          ))}
        </div>
      </div>

      {/* 主要内容 */}
      <div className="header-container">
        {/* Logo区域 */}
        <div className="logo-area">
          <Link to="/" className="logo-link">
            <div className="logo-icon">
              <div className="cat-face">
                <div className="cat-ear left"></div>
                <div className="cat-ear right"></div>
                <div className="cat-eye left"></div>
                <div className="cat-eye right"></div>
                <div className="cat-nose"></div>
                <div className="cat-mouth"></div>
                <div className="cat-whisker left-whisker-1"></div>
                <div className="cat-whisker left-whisker-2"></div>
                <div className="cat-whisker right-whisker-1"></div>
                <div className="cat-whisker right-whisker-2"></div>
              </div>
            </div>
            <div className="logo-text">
              <h1 className="site-title">{siteConfig?.title || '喵星人日记'}</h1>
              <p className="site-subtitle">{siteConfig?.subtitle || '记录与猫咪共度的美好时光'}</p>
            </div>
          </Link>
        </div>

        {/* 导航菜单 */}
        <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink 
                to="/" 
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                end
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="nav-icon">🏠</span>
                <span className="nav-text">首页</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/archive" 
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="nav-icon">📚</span>
                <span className="nav-text">归档</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/about" 
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="nav-icon">🐱</span>
                <span className="nav-text">关于</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/write" 
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="nav-icon">✏️</span>
                <span className="nav-text">写文章</span>
              </NavLink>
            </li>
            {/* 添加个人中心导航项 */}
            <li className="nav-item user-nav-item">
              <NavLink 
                to="/user" 
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="nav-icon">👤</span>
                <span className="nav-text">个人中心</span>
              </NavLink>
            </li>
          </ul>
        </nav>

        {/* 用户区域 */}
        <div className="user-area">
          {currentUser ? (
            <div className="user-profile-wrapper">
              <button 
                className={`user-profile-btn ${userMenuOpen ? 'active' : ''}`}
                onClick={toggleUserMenu}
              >
                <div className="user-avatar">
                  <img 
                    src={currentUser.avatar} 
                    alt={currentUser.name}
                    className="avatar-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://images.unsplash.com/photo-1533738363-b7f9aef128ce?w=40&h=40&fit=crop&crop=face';
                    }}
                  />
                  <div className="online-dot"></div>
                </div>
                <span className="user-name">{currentUser.name}</span>
                <span className="user-menu-arrow">▼</span>
              </button>
              
              {/* 用户下拉菜单 */}
              <div className={`user-dropdown-menu ${userMenuOpen ? 'open' : ''}`}>
                <div className="user-dropdown-header">
                  <img 
                    src={currentUser.avatar} 
                    alt={currentUser.name}
                    className="dropdown-avatar"
                  />
                  <div className="dropdown-user-info">
                    <strong>{currentUser.name}</strong>
                    <small>{currentUser.bio}</small>
                    <div className="user-email">{currentUser.email}</div>
                  </div>
                </div>
                
                <div className="dropdown-divider"></div>
                
                <button 
                  className="dropdown-item"
                  onClick={handleUserCenter}
                >
                  <span className="dropdown-icon">👤</span>
                  <span className="dropdown-text">个人中心</span>
                </button>
                
                <Link 
                  to="/user?tab=posts" 
                  className="dropdown-item"
                  onClick={() => setUserMenuOpen(false)}
                >
                  <span className="dropdown-icon">📝</span>
                  <span className="dropdown-text">我的文章</span>
                </Link>
                
                <Link 
                  to="/user?tab=drafts" 
                  className="dropdown-item"
                  onClick={() => setUserMenuOpen(false)}
                >
                  <span className="dropdown-icon">📄</span>
                  <span className="dropdown-text">草稿箱</span>
                </Link>
                
                <Link 
                  to="/user?tab=settings" 
                  className="dropdown-item"
                  onClick={() => setUserMenuOpen(false)}
                >
                  <span className="dropdown-icon">⚙️</span>
                  <span className="dropdown-text">账户设置</span>
                </Link>
                
                <div className="dropdown-divider"></div>
                
                <button 
                  className="dropdown-item logout"
                  onClick={handleAuth}
                >
                  <span className="dropdown-icon">🚪</span>
                  <span className="dropdown-text">退出登录</span>
                </button>
              </div>
            </div>
          ) : (
            <button onClick={handleAuth} className="login-button">
              <span className="login-icon">🔑</span>
              <span className="login-text">登录/注册</span>
            </button>
          )}
        </div>

        {/* 移动端菜单按钮 */}
        <button 
          className={`menu-toggle ${isMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="菜单"
        >
          <span className="menu-line top"></span>
          <span className="menu-line middle"></span>
          <span className="menu-line bottom"></span>
        </button>
      </div>

      {/* 浮动猫咪装饰 */}
      <div className="floating-cat-decoration">
        <div className="floating-cat cat-1">😺</div>
        <div className="floating-cat cat-2">😸</div>
        <div className="floating-cat cat-3">😻</div>
      </div>
    </header>
  );
};

export default Header;